define('app-ProductInfoBox/viewModel',['./settings', "util", 'async', 'knockout', 'underscore', 'hoverIntent'], function (settings, util, async, ko, _) {
    ko.bindingHandlers.hoverPreview = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var id = 'id' + Math.floor(Math.random() * 1000);
            $(element).hoverIntent({
                over: function () {
                    bindingContext.$root.ShowPreviewFor(ko.unwrap(valueAccessor()), element, id);
                },
                out: function () {
                    bindingContext.$root.HidePreview(id);
                },
                timeout: 150
            });
        },
        update: function () {
        }
    };

    // adl variables
    $(document).ready(function () {
        var frostedContainer = $('.adl-frostedContentsInner:visible:first');
        var newTemplate = false;
        if ($('.adl-frostedContentsInner').is('#frostedContentsInnerRight')) {
            newTemplate = true;
        };

        if (frostedContainer.is(':visible')) {
            //eg {{"Walking in Almeria"}} not {{"Walking in Almeria {ENTER} QQQQ"}}
            if (newTemplate == true) {
                var productName = frostedContainer.find(".adl-title").text().trim();
            } else {
                var productName = frostedContainer.find("h1").clone().children().remove().end().text().trim();
            }
            AdlAddUpdateItem('productName', productName);

            //eg HB
            var boardBasis = frostedContainer.data("adlboardbasis").trim();
            AdlAddUpdateItem('boardBasis', boardBasis);

            //eg EL TOYO, ALMERIA, SPAIN
            var packageCode = frostedContainer.data("adlpackagecode").trim();
            AdlAddUpdateItem('packageCode', packageCode);

            //eg EL TOYO, ALMERIA, SPAIN
            
            if (newTemplate == true) {
                var destination = frostedContainer.find(".adl-destination").text().trim();
            } else {
                var destination = frostedContainer.find("h3").text().trim();
            }
            AdlAddUpdateItem('destination', destination);

            

            //eg 7
            var noOfNights = frostedContainer.find(".nights").text().trim();
            localStorage.setItem("numberOfNights", noOfNights);
            AdlAddUpdateItem('numberOfNights', noOfNights);

            //eg 2
            var passengerNumber = frostedContainer.find(".pass").text().trim();
            AdlAddUpdateItem('passengerNumber', passengerNumber);

            // eg £569
            var price = frostedContainer.find('[data-adl-starting-price]').data("adl-starting-price");
            AdlAddUpdateItem('startingPrice', price);

            var oneholidaypin = "";
            var holidaypins = "";

            $('.productContent span.featureInfoPopUp').not('.icon-holder').each(function () {
                if (!(oneholidaypin === "")) {
                    holidaypins = holidaypins + ',';
                }

                oneholidaypin = $(this).text().trim();
                holidaypins += oneholidaypin;
            });

            AdlAddUpdateItem('holidayPins', holidaypins);

            // boardBasis
            var boardBasisFromStorage = localStorage.getItem('boardBasis');

            if (typeof boardBasisFromStorage !== "undefined" && boardBasisFromStorage) {
                AdlAddUpdateItem('boardBasis', boardBasisFromStorage);
            }

            // destination
            var destinationFromStorage = localStorage.getItem('destination');

            if (typeof destinationFromStorage !== "undefined" && destinationFromStorage) {
                AdlAddUpdateItem('destination', destinationFromStorage);
            }

            // numberOfNights
            var numberOfNights = localStorage.getItem('numberOfNights');
            if (numberOfNights) {
                AdlAddUpdateItem('numberOfNights', numberOfNights);
            }

            // carrierPreference
            var carrierPreference = localStorage.getItem('carrierPreference');
            if (carrierPreference) {
                AdlAddUpdateItem('carrierPreference', carrierPreference);
            }

            // passengerNumber
            var passengerNumber = localStorage.getItem('passengerNumber');
            if (passengerNumber) {
                AdlAddUpdateItem('passengerNumber', passengerNumber);
            }

            // departurePoint
            var departurePoint = localStorage.getItem('departurePoint');
            if (departurePoint) {
                AdlAddUpdateItem('departurePoint', departurePoint);
            }

            // departureDate
            var departureDate = localStorage.getItem('departureDate');
            if (departureDate) {
                AdlAddUpdateItem('departureDate', departureDate);
            }

            // hostList
            var hostList = localStorage.getItem('hostList');
            if (hostList) {
                AdlAddUpdateItem('hostList', hostList);
            }


            // specialInterest
            var specialInterest = localStorage.getItem('specialInterest');
            if (specialInterest) {
                AdlAddUpdateItem('specialInterest', specialInterest);
            }

            // Behavioural information
            //BHsearchResultsSeen
            var previousPageName = localStorage.getItem('previousPageName');
            var BHsearchResultsSeen = (previousPageName === "search") ? "yes" : "no";
            AdlAddUpdateItem('BHsearchResultsSeen', BHsearchResultsSeen);

            //BHsearchResultsAction
            var BHsearchResultsAction = localStorage.getItem('BHsearchResultsAction');
            if (BHsearchResultsAction) {
                AdlAddUpdateItem('BHsearchResultsAction', BHsearchResultsAction);
            }


            //BHsearchMethodWidgetType
            var BHsearchMethodWidgetType = localStorage.getItem('BHsearchMethodWidgetType');
            if (BHsearchMethodWidgetType) {
                AdlAddUpdateItem('BHsearchMethodWidgetType', BHsearchMethodWidgetType);
            }


            //BHsearchMethodLinkType
            var BHsearchMethodLinkType = localStorage.getItem('BHsearchMethodLinkType');
            if (BHsearchMethodLinkType) {
                AdlAddUpdateItem('BHsearchMethodLinkType', BHsearchMethodLinkType);
            }

            //BHsearchMethodPagePosition
            var BHsearchMethodPagePosition = localStorage.getItem('BHsearchMethodPagePosition');
            if (BHsearchMethodPagePosition) {
                AdlAddUpdateItem('BHsearchMethodPagePosition', BHsearchMethodPagePosition);
            }

            //BHsearchMethodPageType
            var BHsearchMethodPageType = localStorage.getItem('BHsearchMethodPageType');
            if (BHsearchMethodPageType) {
                AdlAddUpdateItem('BHsearchMethodPageType', BHsearchMethodPageType);
            }


            // product page - now that all the variables have been added to the data layer, make the direct call to get them picked up
            util.satelliteTrack('travel product page');
        }
    });

    return function () {
        var self = this;
        self.CurrentSlide = 0;
        self.Slides = ko.observableArray([]);
        self.Lock = false;

        self.ShowPreviewFor = function (slide, element, id) {
            var picture = $(slide).find('img').first();
            var popup = $('<div />').addClass('preview').addClass(id);
            var img = $('<img />').attr('src', picture.attr('src'))
                        .attr('alt', picture.attr('alt'))
                        .attr('title', picture.attr('alt'))
                        .attr('width', '150');
            popup.append(img);
            popup.css({
                right: 10 + 'px',
                top: 70 + 'px',
                'z-index': 999
            });
            popup.hide();
            $(slide).parents(settings.container).append(popup);
            popup.fadeIn(50);
        };

        self.HidePreview = function (id) {
            var preview = $(settings.container + ' .' + id);
            preview.fadeOut(80, function () {
                preview.remove();
            });
        };

        self.HideAllSlides = function (cb) {
            var slides = [];
            _.each(self.Slides(), function (s) {
                slides.push(function (callback) {
                    $(s).fadeOut(80, callback);
                });
            });

            async.parallel(slides, cb);
        };

        self.GoPrevious = function () {
            if (self.Lock) return;

            self.Lock = true;
            self.HideAllSlides(function () {
                // Take the current slide and move it to the right (show it if its not visible)
                var activeSlide = self.CurrentSlide;
                var currentLeft = self.CurrentSlide === 0 ? self.Slides().length - 1 : self.CurrentSlide - 1;
                var farLeft = currentLeft === 0 ? self.Slides().length - 1 : currentLeft - 1;
                var currentRight = self.CurrentSlide === self.Slides().length - 1 ? 0 : self.CurrentSlide + 1;

                var newRight = self.Slides()[activeSlide];
                var newLeft = self.Slides()[farLeft];
                var newActive = self.Slides()[currentLeft];
                var oldRight = self.Slides()[currentRight];

                newRight.ActiveSlide(false);
                newActive.ActiveSlide(true);

                $(newRight).removeClass('activeImage').addClass('rightImage').removeClass('leftImage');
                $(newActive).removeClass('leftImage').addClass('activeImage');
                $(oldRight).removeClass('rightImage');
                $(newLeft).addClass('leftImage');

                self.CurrentSlide = currentLeft;

                if (newActive.Hidden()) {
                    self.GoPrevious();
                    return;
                }

                // Now show the slides
                $(newActive).fadeIn(50, function () {
                    self.Lock = false;
                });
            });
        };

        self.GoNext = function () {
            if (self.Lock) return;

            self.Lock = true;
            self.HideAllSlides(function (cb) {
                // Take the current slide and move it to the right (show it if its not visible)
                var activeSlide = self.CurrentSlide;
                var currentLeft = self.CurrentSlide === 0 ? self.Slides().length - 1 : self.CurrentSlide - 1;
                var currentRight = self.CurrentSlide === self.Slides().length - 1 ? 0 : self.CurrentSlide + 1;
                var farRight = currentRight === self.Slides().length - 1 ? 0 : currentRight + 1;

                var newRight = self.Slides()[farRight];
                var newLeft = self.Slides()[activeSlide];
                var newActive = self.Slides()[currentRight];
                var oldLeft = self.Slides()[currentLeft];

                newLeft.ActiveSlide(false);
                newActive.ActiveSlide(true);

                $(newRight).addClass('rightImage');
                $(newActive).removeClass('rightImage').addClass('activeImage');
                $(oldLeft).removeClass('leftImage');
                $(newLeft).addClass('leftImage').removeClass('activeImage');

                self.CurrentSlide = currentRight;

                if (newActive.Hidden()) {
                    self.GoNext();
                    return;
                }

                // Now show the slides
                $(newActive).fadeIn(50, function () {
                    self.Lock = false;
                });
            });
        };

        self.GoTo = function (slide) {
            if (self.Lock) return;

            self.Lock = true;
            self.HideAllSlides(function () {
                var n = 0;
                _.each(self.Slides(), function (s) {
                    // We detect which slide number should now become active
                    // predicated on the assumption that we'll never have two
                    // slides with exactly the same contents.
                    if ($(s).html() === $(slide).html()) {
                        self.CurrentSlide = n;
                        s.ActiveSlide(true);
                    }
                    else {
                        s.ActiveSlide(false);
                    }
                    n++;
                });

                // Take the current slide and move it to the right (show it if its not visible)
                $(self.Slides()[self.CurrentSlide]).removeClass('leftImage').addClass('activeImage').removeClass('rightImage').fadeIn(50, function () {
                    // Now set the left slide
                    var leftSide = self.CurrentSlide;
                    if (leftSide === 0) leftSide = self.Slides().length - 1;
                    else leftSide = leftSide - 1;

                    $(self.Slides()[leftSide]).addClass('leftImage').removeClass('rightImage').removeClass('activeImage').fadeOut(50, function () {
                        // Now set the slide to the right
                        var rightSlide = self.CurrentSlide;
                        if (rightSlide === self.Slides().length - 1) rightSlide = 0;
                        else rightSlide = rightSlide + 1;
                        $(self.Slides()[rightSlide]).addClass('rightImage').removeClass('leftImage').removeClass('activeImage').fadeOut(50, function () {
                            self.Lock = false;
                        });
                    });
                });
            });

        };

        self.SetData = function (images) {

            if (images.length === 1) {
                // We only have the one image so don't bother with a carousel.
                $('.slideLeft, .slideRight, .slides').hide();

                //frost() requires an image with the class activeImage to be able to generate the blurry background of hope and wonder
                //Only add the activeImage class if the browser has a width larger than, or the same size as, a tablet
                if ($(window).width() >= 768) {
                    $(settings.container + ' img').first().removeClass('leftImage').parent().addClass('activeImage');
                }

                return;
            }

            var n = 0;
            _.each(images, function (image) {
                image.ActiveSlide = ko.observable(false);
                image.Hidden = ko.observable(false);
                if ($(image).is(':visible')) {
                    image.ActiveSlide(true);
                    self.CurrentSlide = n;
                }

                n++;
            });
            self.Slides(images);
            $(self.Slides()[self.CurrentSlide]).fadeIn(50).addClass('activeImage');

            function isEmpty(el) {
                return !$.trim(el.html());
            }

            if (isEmpty($('#frostedContentsInner'))) {
                $('#frostedContents').hide();
            }

            if ($('.firstRowInner')[0]) {
                // if class firstRowInner exists, then this is the homepage, therefore hide the slide pills and text pop-up
                $('.slides, .heroName').hide();
            }

        };
    };
});
